import { SET_SECTOR_HOTELS, SET_CITY_HOTELS, UPDATE_HOTEL_LOADING, SET_HOTEL_META } from '../actions/types';
import update from 'immutability-helper';

const hotelState = {
    "sector":[],
    "city":[],
    "update_hotel_loading":false,
    "meta":{}
}

export function SetHotel(state = hotelState, action){
    switch(action.type){
        case SET_SECTOR_HOTELS:
            return update(state, {sector:{$set:action.payload}});    
        case SET_CITY_HOTELS:
            return update(state, {city:{$set:action.payload}});  
        case UPDATE_HOTEL_LOADING:
            return update(state, {update_hotel_loading:{$set:action.payload}});
        case SET_HOTEL_META:
            return update(state, {meta:{$set:action.payload}});           
        default:
            return state;    
    }
}